export const Chips = ({ options, value, onChange, testid }) => {
  const toggle = (o) => onChange(value.includes(o) ? value.filter((v) => v !== o) : [...value, o]);
  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {options.map((o, i) => {
        const on = value.includes(o);
        return (
          <button type="button" key={o} onClick={() => toggle(o)} data-testid={`${testid}-opt-${i}`}
            className={`border px-3 py-1.5 text-xs transition-colors duration-200 ${on ? "border-red-600 bg-red-600 text-white" : "border-slate-700 bg-black/30 text-slate-300 hover:border-slate-500 hover:text-white"}`}>
            {o}
          </button>
        );
      })}
    </div>
  );
};
